<p-dialog [(visible)]="display" header="{{title}}" [modal]="true" [style]="{width: '70vw'}" (onHide)="closeModal()" [focusOnShow]="false">
  <form class="card mt-2" [formGroup]="form" (ngSubmit)="savePtoEarned()">
    <div class="card-body">
      <div class="row">
        <div class="col-12">

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Employee</b>
            </div>
            <div class="col-8">
              <p-autoComplete *ngIf="disableName === false" [style]="{'width': '100%'}" [inputStyle]="{'width': '100%'}" [(ngModel)]="selectedUserEmployee"
                            [suggestions]="userList" (completeMethod)="getStaffList($event)" field="name" dataKey="id"
                            [ngModelOptions]="{standalone: true}" [minLength]="1" [autoHighlight]="true"
                            (onSelect)="selectStaff($event)" [forceSelection]="true"
                            (onClear)="clearStaff($event)"></p-autoComplete>
              <input *ngIf="disableName" type="text" disabled="disabled" class="form-control mt-2" [(ngModel)]="prefixText" [ngModelOptions]="{standalone: true}" />
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Date Earned</b>
            </div>
            <div class="col-8">
              <input type="date" class="form-control mt-2" formControlName="dateEarnedString" />
              <app-validation-message [form]="form" [path]="'dateEarnedString'" [label]="'Date Earned'"></app-validation-message>
            </div>            
          </div>

          <div class="row" style="min-height: 46px;">
            <div class="col-4 d-flex align-items-center">
              <b>
                Net PTO
                <span *ngIf="showMaxNet" style="font-size: small;" class="ml-1">(Max: {{maxNet}})</span>
              </b>
            </div>
            <div class="col-8 mt-2 d-flex align-items-center">
              <span style="font-style: italic;">{{totalNet}}</span>              
            </div>
          </div>

          <div class="row" style="min-height: 46px;">
            <div class="col-4 d-flex align-items-center">
              <b>YTD PTO</b>
            </div>
            <div class="col-8 mt-2 d-flex align-items-center">
              <span style="font-style: italic;">{{totalYtd}}</span>              
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>PTO Earned</b>
            </div>
            <div class="col-4">
              <input type="number" step="1" style="width: 85%; display: inline-block;" placeholder="PTO Hours" class="form-control mt-2" formControlName="ptoHours" /> h
              <app-validation-message [form]="form" [path]="'ptoHours'" [label]="'Hours'"></app-validation-message>
            </div>
            <div class="col-4">
              <input type="number" min="-59" max="59" step="1" style="width: 85%; display: inline-block;" placeholder="PTO Minutes" class="form-control mt-2" formControlName="ptoMinutes" /> m
              <app-validation-message [form]="form" [path]="'ptoMinutes'" [label]="'Minutes'"></app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Comments</b>
            </div>
            <div class="col-8">
              <textarea style="width: 100%;" class="form-control mt-2" formControlName="comments"></textarea>
              <app-validation-message [form]="form" [path]="'comments'" [label]="'Comments'"></app-validation-message>
            </div>            
          </div>

        </div>
      </div>
    </div>    
  </form>
  <ng-template pTemplate="footer">
    <div class="row w-100 m-0">
      <div class="col text-left pl-0">
        <button class="btn btn-secondary" type="button" (click)="closeModal()">Cancel</button>
      </div>
      <div class="col text-right pr-0">
        <button class="btn btn-primary" type="submit" (click)="savePtoEarned()" [disabled]="disableButtons">Save</button>
      </div>
    </div>
  </ng-template>
</p-dialog>
